const AUTH_METHOD = {
  BASIC: "BASIC",
  ACCOUNT_SERVICE: "ACCOUNT_SERVICE",
  OAUTH2: "OAUTH2"
}

export default AUTH_METHOD
